import React from "react";
import { path } from "ramda";
import { Row, Col } from "antd";
import { withTheme } from "styled-components";
import { Element } from "react-scroll";
import I18n from "../../i18n";
import { BreadcrumbPath } from "../navigation/OBreadcrumb";
import { Colors, Metrics } from "../../theme";
import { TargetValueType } from "../../containers/ReportPanels/CompareValuePanel";
import { isFillAlive } from "../../util";
import InfoErrorStatus from "../../constants/errorStatus";
import { LimitDataBox, SomethingWentWrongBox } from "./ErrorGraphBox";
import { ReportErrorHandler } from "./ErrorGraphBox";

function getErrorOrDo(target, doCreate){
	if(target===undefined){
		return undefined;
	}
	const { error } = target;
	if(error === undefined){
		return doCreate();
	}
	return { error };
}
export const ResultContainer = ({path, children})=>{
	return (<React.Fragment>
		<BreadcrumbPath path={path} overflowDots = {false} />
		{children}
	</React.Fragment>);
};
export const ResultGraphBox = ({
	style,
	id,
	summary, previousSummary,
	breadcrumbPath,
	exclude, pick, 
	drawList,
	isVertical, 
	colorType,
	onGraphValueClick,
})=>{
	const DrawList = drawList;
	let mutateSum = {
		primary: summary, 
		secondary: previousSummary
	};
	const isFillPrevious = isFillAlive(previousSummary);
	const spanSize = isFillPrevious ? 12 : 24;
	return (
		<Row gutter={Metrics.button.bigSpaceMargin}>
			<Col span={spanSize}>
				<ReportErrorHandler value={mutateSum.primary}>
					<DrawList 
						pick={pick}
						single={isFillPrevious}
						summary={mutateSum.primary} 
						isVertical={isVertical}
						colorType={TargetValueType.Primary}
						onClick={onGraphValueClick}
						exclude={exclude}
					/>
				</ReportErrorHandler>
			</Col>
			{isFillPrevious ? <Col span={spanSize}>
				<ReportErrorHandler value={mutateSum.secondary}>
					<DrawList 
						pick={pick}
						single={isFillPrevious}
						summary={mutateSum.secondary} 
						previousSummary={mutateSum.primary} 
						isVertical={isVertical}
						colorType={TargetValueType.Secondary}
						onClick={onGraphValueClick}
						exclude={exclude}
					/>
				</ReportErrorHandler>
			</Col> : undefined}
		</Row>
	);
};
export default withTheme(ResultGraphBox);


// WEBPACK FOOTER //
// ./src/components/report/ReportGraphResultBox.js